// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Store from "../../store/Store.bs.js";
import * as React from "react";

function rs(prim) {
  return prim;
}

function getClassName(sort, activeSort, className) {
  if (sort === activeSort) {
    return className + " " + className + "--active";
  } else {
    return className;
  }
}

function SortControls(Props) {
  var className = Props.className;
  var sort = Store.useAppSelector(function (state) {
        return state.sort;
      });
  var dispatch = Store.useAppDispatch(undefined);
  var sp = "\u00A0";
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: getClassName(sort, /* NoSort */0, className),
                  onClick: (function (param) {
                      return Curry._1(dispatch, {
                                  TAG: /* Sort */1,
                                  _0: /* NoSort */0
                                });
                    })
                }, "❌" + sp), React.createElement("div", {
                  className: getClassName(sort, /* SortByDate */5, className),
                  onClick: (function (param) {
                      return Curry._1(dispatch, {
                                  TAG: /* Sort */1,
                                  _0: /* SortByDate */5
                                });
                    })
                }, "🕒" + sp + "⬆️"), React.createElement("div", {
                  className: getClassName(sort, /* SortByDateDesc */6, className),
                  onClick: (function (param) {
                      return Curry._1(dispatch, {
                                  TAG: /* Sort */1,
                                  _0: /* SortByDateDesc */6
                                });
                    })
                }, "🕒" + sp + "⬇️"), React.createElement("div", {
                  className: getClassName(sort, /* SortByTitle */1, className),
                  onClick: (function (param) {
                      return Curry._1(dispatch, {
                                  TAG: /* Sort */1,
                                  _0: /* SortByTitle */1
                                });
                    })
                }, "⌨️" + sp + "⬆️"), React.createElement("div", {
                  className: getClassName(sort, /* SortByTitleDesc */2, className),
                  onClick: (function (param) {
                      return Curry._1(dispatch, {
                                  TAG: /* Sort */1,
                                  _0: /* SortByTitleDesc */2
                                });
                    })
                }, "⌨️" + sp + "⬇️"), React.createElement("div", {
                  className: getClassName(sort, /* SortByScore */3, className),
                  onClick: (function (param) {
                      return Curry._1(dispatch, {
                                  TAG: /* Sort */1,
                                  _0: /* SortByScore */3
                                });
                    })
                }, "🔢" + sp + "⬆️"), React.createElement("div", {
                  className: getClassName(sort, /* SortByScoreDesc */4, className),
                  onClick: (function (param) {
                      return Curry._1(dispatch, {
                                  TAG: /* Sort */1,
                                  _0: /* SortByScoreDesc */4
                                });
                    })
                }, "🔢" + sp + "⬇️"));
}

var make = SortControls;

export {
  rs ,
  getClassName ,
  make ,
  
}
/* Store Not a pure module */
